<template>
  <div id="print_001" class="receipt fontArial">
    <div style="border-top: 2px dashed black">
      <div
        v-if="restaurant.logo"
        class="logo"
        style="align-items: center; text-align: center; padding: 5px"
      >
        <img :src="restaurant.logo" alt="" style="width: 30%" />
      </div>
      <h5 align="center" class="header mb-2">
        {{ order.type_title }}
      </h5>
      <h5 align="center">
        {{ $t("receipt") }}
      </h5>
    </div>

    <table class="table-sm table-header">
      <tbody>
        <tr>
          <td class="text-left no_border p-0">{{ $t("Order") }} Nº:</td>
          <td class="text-left no_border p-0">
            {{ order.invoice_number }} ({{ $t(order.order_type) }})

            <span v-if="order.is_void" class="badge badge-secondary">{{
              $t("Voided")
            }}</span>
          </td>
        </tr>
        <tr>
          <td class="text-left no_border p-0">{{ $t("Date") }}:</td>
          <td v-if="order.id" class="text-left no_border p-0">
            {{ order.created_at | formatDateOnly }}
          </td>
        </tr>
        <tr>
          <td class="text-left no_border p-0">{{ $t("Time") }}:</td>
          <td v-if="order.id" class="text-left no_border p-0">
            {{ order.created_at | formatToTime }}
          </td>
        </tr>
        <tr>
          <td class="text-left no_border p-0">{{ $t("Cashier") }}:</td>
          <td class="text-left no_border p-0">
            {{ order.seller_name }}
          </td>
        </tr>
        <tr>
          <td class="text-left no_border p-0">{{ $t("Customer") }}:</td>
          <td class="text-left no_border p-0">
            {{ order.customer != null ? order.customer.name : "n-a" }}
          </td>
        </tr>
        <tr v-if="order.location_name">
          <td class="text-left no_border p-0">{{ $t("Table/Location") }}:</td>
          <td class="text-left no_border p-0">
            {{ order.location_name }}
          </td>
        </tr>
        <tr v-if="order.table_name">
          <td class="text-left no_border p-0">
            <span v-if="order.order_type == 'walk_in'">
              {{ $t("Table") }}
            </span>
            <span v-else>
              {{ $t("Room") }}
            </span>
            :
          </td>
          <td class="text-left no_border p-0">
            {{ order.table_name }}
          </td>
        </tr>
        <tr
          v-if="
            order.payment_types &&
              order.payment_types.length > 0 &&
              ((order.amount_paid > 0 &&
                order.data_cash_receive &&
                dataCashEnter) ||
                order.is_credit == true)
          "
        >
          <td class="text-left no_border p-0">{{ $t("Payment Type") }} :</td>
          <td class="text-left no_border p-0">
            {{ order.payment_types[0].title }}
          </td>
        </tr>

        <tr v-if="order.note">
          <td class="text-left no_border p-0">{{ $t("note") }} :</td>
          <td class="text-left no_border p-0">
            {{ order.note }}
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <table class="table p-0" style="border-top: 2px dashed black" align="left">
      <tbody>
        <tr v-for="(item, index) in order.sale_details" :key="index">
          <td class="text-left no_border">
            <!-- <span style="padding-right: 10px">{{ item.qty }}</span> -->
            <p>
              <template v-if="item.venueitem.code">
                {{ item.venueitem.code.toUpperCase() | str4 }} -
              </template>

              {{ item.venueitem_name }}
            </p>

            <p v-if="item.discount > 0" class="item-description pl-4">
              &nbsp; Disc:
              <span v-if="item.item_discount_percent">
                &nbsp; ({{ item.item_discount_percent }}%)
              </span>
            </p>

            <template v-for="(op, op_index) in item.options">
              <p :key="op_index" class="item-description pl-4">
                &nbsp; &nbsp; {{ op.title }}
              </p>

              <template v-for="(opl, opl_index) in op.option_optionvalue">
                <p
                  :key="opl_index + 'OPL' + op_index"
                  class="item-description pl-4"
                >
                  &nbsp; --- {{ opl.optionvalue_title }}
                </p>
              </template>
            </template>

            <p class="item-description pl-4">
              {{ item.note }}
            </p>
          </td>
          <td width="100px" style="border: 0">
            <p>x {{ item.qty }}</p>
          </td>
          <td class="no_border text-right">
            {{
              (item.price * item.qty)
                | commaNumberRate(order.exchangerate, order.currency_code)
            }}
            <p />
            <p v-if="item.discount > 0" class="item-description">
              {{
                item.discount
                  | commaNumberRate(order.exchangerate, order.currency_code)
              }}
            </p>

            <template v-for="(op, op_index) in item.options">
              <p :key="op_index" class="item-description pl-4">
                ---
              </p>

              <template v-for="(opl, opl_index) in op.option_optionvalue">
                <p
                  :key="opl_index + 'OPL' + op_index"
                  class="item-description pl-4"
                >
                  {{
                    (opl.optionvalue_price * item.qty)
                      | commaNumberRate(order.exchangerate, order.currency_code)
                  }}
                </p>
              </template>
            </template>
          </td>
        </tr>
      </tbody>
    </table>

    <table class="table" style="border-bottom: 2px dashed black">
      <tbody class="tbody">
        <tr>
          <td class="text-right no_border p-0">{{ $t("Item Count") }} :</td>
          <td class="text-right no_border p-0">
            {{ totalItemCount }}
          </td>
        </tr>
        <tr>
          <td class="text-right no_border p-0">{{ $t("Sub Total") }} :</td>
          <td class="text-right no_border p-0">
            {{
              order.sub_total
                | commaNumberRate(order.exchangerate, order.currency_code)
            }}
            {{ order.currency_code }}
          </td>
        </tr>
        <tr>
          <td class="text-right no_border p-0">{{ $t("Discount") }} :</td>
          <td class="text-right no_border p-0">
            {{
              order.discount
                | commaNumberRate(order.exchangerate, order.currency_code)
            }}
            {{ order.currency_code }}
          </td>
        </tr>

        <tr v-if="order.order_type == 'delivery'">
          <td class="text-right no_border p-0">{{ $t("Delivery Fee") }} :</td>
          <td class="text-right no_border p-0">
            {{
              order.delivery_fee
                | commaNumberRate(order.exchangerate, order.currency_code)
            }}
            {{ order.currency_code }}
          </td>
        </tr>

        <template v-if="restaurant.tax_type == 'EXCLUSIVE'">
          <tr>
            <td class="text-right no_border p-0">
              {{ order.service_charge || 0 }} % {{ $t("Service Charge") }} :
            </td>
            <td class="text-right no_border p-0">
              {{
                order.service_charge_amount
                  | commaNumberRate(order.exchangerate, order.currency_code)
              }}
              {{ order.currency_code }}
            </td>
          </tr>
          <tr>
            <td class="text-right no_border p-0">
              {{ order.tax_percentage || 0 }} % {{ $t("Tax") }} :
            </td>
            <td class="text-right no_border p-0">
              {{
                order.tax_amount
                  | commaNumberRate(order.exchangerate, order.currency_code)
              }}
              {{ order.currency_code }}
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <h5 style="text-align: center" />
    <table class="table">
      <tbody>
        <tr>
          <th class="text-right no_border p-0">
            <span v-if="order.number_split > 0">{{ $t("Total Due") }}</span>
            <span v-else>{{ $t("Amount to be Paid") }} :</span>
          </th>

          <th class="text-right no_border p-0">
            <span v-if="restaurant.tax_type === 'EXCLUSIVE'">
              {{
                order.amount_to_be_paid
                  | commaNumberRate(order.exchangerate, order.currency_code)
              }}
            </span>
            <span v-else>
              {{
                order.total
                  | commaNumberRate(order.exchangerate, order.currency_code)
              }}
            </span>
          </th>
          <th class="text-right no_border p-0" width="10px">
            {{ order.currency_code }}
          </th>
        </tr>
        <template v-if="!(order.number_split > 0)">
          <tr v-for="(rate, index) in exchange_rates" :key="index">
            <th class="text-right no_border p-0" style="width: 50%" />
            <th class="text-right no_border p-0">
              <span v-if="restaurant.tax_type === 'EXCLUSIVE'">
                {{ formatExchange(order.amount_to_be_paid, rate) }}
              </span>
              <span v-else> {{ formatExchange(order.total, rate) }} </span>
            </th>
            <th class="text-right no_border p-0">
              {{ rate.code }}
            </th>
          </tr>
        </template>

        <tr v-if="order.number_split > 0">
          <th class="text-right no_border p-0">
            {{ $t("Amount to be Paid") }} :
          </th>
          <th class="text-right no_border p-0">
            {{
              (order.amount_to_be_paid / order.number_split)
                | commaNumberRate(order.exchangerate, order.currency_code)
            }}
          </th>
          <th class="text-right no_border p-0" style="width: 2%">
            {{ order.currency_code }}
          </th>
        </tr>
        <template v-if="order.number_split > 0">
          <tr v-for="(rate, index) in exchange_rates" :key="index">
            <th class="text-right no_border p-0" style="width: 50%" />
            <th class="text-right no_border p-0">
              <span v-if="restaurant.tax_type == 'EXCLUSIVE'">
                {{ formatExchange(order.amount_to_be_paid, rate) }}</span
              >
              <span v-else> {{ formatExchange(order.total, rate) }} </span>
            </th>
            <th class="text-right no_border p-0">
              {{ rate.code }}
            </th>
          </tr>
        </template>
      </tbody>
    </table>

    <table class="table">
      <tr>
        <th class="text-right no_border p-0" style="width: 50%">
          {{ $t("Amount Paid") }} :
        </th>
        <th class="text-right no_border p-0">
          {{
            order.amount_paid
              | commaNumberRate(order.exchangerate, order.currency_code)
          }}
          {{ order.currency_code }}
        </th>
      </tr>
      <tr>
        <th class="text-right no_border p-0" style="width: 50%">
          {{ $t("Amount Due") }} :
        </th>
        <th class="text-right no_border p-0">
          {{
            order.credit
              | commaNumberRate(order.exchangerate, order.currency_code)
          }}
          {{ order.currency_code }}
        </th>
      </tr>
    </table>

    <table v-if="order.number_split > 0">
      <tr>
        <th>{{ $t("Split Payment") }}: ({{ order.number_split }}p)</th>
      </tr>
      <tr>
        <th>{{ $t("Cash Tendered") }}:</th>
        <th>
          {{
            (order.amount_to_be_paid / order.number_split)
              | commaNumberRate(order.exchangerate, order.currency_code)
          }}
          {{ order.currency_code }}
        </th>
      </tr>
    </table>

    <template
      v-if="order.amount_paid > 0 && order.data_cash_receive && dataCashEnter"
    >
      <table style="padding: 10px; width: 100%">
        <tr v-for="(row, index) of dataCashEnter" :key="index">
          <td style="text-align: right; width: 50%">
            <span v-if="index === 0" style="font-size: 13px"
              >{{ $t("Cash Received") }}:</span
            >
          </td>
          <th>
            <p style="text-align: right; font-size: 13px">
              {{ (row.cash_enter || 0) | commaNumber }}
              {{ row.code }}
            </p>
          </th>
        </tr>
      </table>

      <table style="padding: 10px; width: 100%">
        <tr>
          <td style="text-align: right; width: 50%">
            <span style="font-size: 13px">{{ $t("Change") }}: </span>
          </td>
          <th style="text-align: right">
            <div style="text-align: right; font-size: 13px">
              <span v-for="(row, index) of dataCashEnter" :key="index">
                {{
                  dataCashReceive.data_cash_change
                    | commaNumberRate(row.rate, row.code)
                }}
                {{ row.code }}
                <span v-if="index != dataCashEnter.length - 1"> =</span>
              </span>
            </div>
          </th>
        </tr>
      </table>
    </template>

    <div
      style="text-align: center; border-top: 2px dashed black; padding: 10px"
    >
      <p class="quoted">Order Ref : {{ order.id }}</p>
      <div
        v-if="restaurant.bcel_onpay_qr"
        class="logo"
        style="align-items: center; text-align: center; padding: 10px"
      >
        <img :src="restaurant.bcel_onpay_qr" alt="" style="width: 140px" />
      </div>

      <p>{{ restaurant.receipt_footer_label }}</p>

      <!-- <p>Powered by discoverlaos.today</p> -->
    </div>
  </div>
</template>
<script>
  import store from "@/store";

  export default {
    name: "PreviewInvoice",
    props: {
      order: Object,
    },
    data: () => ({
      exchange_rates: [],
      base_currency: {},
       baseRate: 1,
    }),

    computed: {
      dataCashEnter() {
        if (!this.dataCashReceive) return [];
        return _.orderBy(this.dataCashReceive.data_cash_enter, [
          "cash_enter",
          "desc",
        ]);
      },

      dataCashReceive() {
        if (!this.order.data_cash_receive) return {};
        return JSON.parse(this.order.data_cash_receive);
      },

      restaurant() {
        return store.getters["restaurant/restaurant"];
      },

      list_exchange_rates() {},

      totalItemCount() {
        let qty = 0;
        _.forEach(this.order.sale_details, function(item) {
          qty += item.qty;
        });
        return qty;
      },

      pre_invoice() {
        return store.getters["pre_printing/pre_invoice"];
      },

      selected_currency() {
        return store.getters["currency/selected_currency"];
      },

      auth_user() {
        return store.getters["auth/user"];
      },
    },
    mounted() {
      this.get_base_currency();
    },
    methods: {
      get_base_currency() {
      const rates = JSON.parse(this.order.all_exchangerate || "[]");

      // 1) REAL base currency = default:true (KIP)
      const base = rates.find(r => r && (r.default === true || r.default === 1 || r.is_base === true));
      this.baseRate = base ? Number(base.rate) : 1;
      this.base_currency = base || {};

      // 2) Remove ONLY the current view currency from the list (THB),
      // so you can print the other currencies under it (KIP, USD, ...)
      const selectedCode = this.order.currency_code;
      this.exchange_rates = rates.filter(r => r && r.code !== selectedCode);
    },
      formatExchange(value, rate) {
      const v = Number(String(value ?? "0").replace(/,/g, "")) || 0;

      const targetRate = Number(rate?.rate) || 1;
      const baseRate = Number(this.baseRate) || 1;

      const converted = (v * targetRate) / baseRate;

      // if (rate.code === "KIP") {
      //   return Math.round(converted).toLocaleString();
      // }

      return converted.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    },
  };
</script>

<style lang="css">
  .fontArial {
    font-family: Arial, Helvetica, sans-serif !important;
    font-weight: 700;
    color: #000000;
  }

  .receipt > .table th > .table td {
    border: none !important;
    padding: 2px;
  }

  .receipt > .table-sm th > .table-sm td {
    padding: 2px;
    border: none !important;
  }

  @media only screen and (max-width: 600px) {
    .receipt {
      width: auto !important;
    }

    .print_invoice_modal {
      width: auto !important;
    }
  }

  .box-invoice {
    border: 1px dotted;
    border-radius: 3px;
  }
</style>
